import { render } from "./RegistrationForm.vue?vue&type=template&id=57de561b"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/packs/components/RegistrationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57de561b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57de561b', __exports__)) {
    api.reload('57de561b', __exports__)
  }
  
  module.hot.accept("./RegistrationForm.vue?vue&type=template&id=57de561b", () => {
    api.rerender('57de561b', render)
  })

}


export default __exports__